<template>
    <div class="mdedit-container" v-if="isMounted">
        <BaseInputWithContextMenu
        :target-id="inputElementId"
        :is-read-only="isReadOnlyState"
        :value="value"
        :enable-speech-features="enableSpeechFeatures"
        :enable-system-options="true"
        @input="onInput"
        @control-changed="setChangedStatus"
        :control-id="Id"
        >
        <div :class="this.classValue" :data-label="Label ? labelCaption : null" :id="'dv_'+Id">
            <datalist :id="'list_'+Id">
                <option v-for="(item,index) in this.DataList" :key="index" :value="item"/>
            </datalist>

            <input
                v-mask="internalMask"
                :type="internalPropertyType"
                :maxlength="MaxLengthProp"
                :readonly="isReadOnly"
                :min="Min"
                :autofocus="isAutoFocus"
                :max="Max"
                :step="StepProp"
                :ref="Name"
                :tabindex="isReadOnly ? -1 : 0"
                :list="'list_'+Id"
                :id="inputElementId"
                :name="inputElementId"
                class="form-control"
                :placeholder="internalPlaceholder"
                :autocomplete="autocomplete"
                v-on:blur="onBlur"
                v-on:change="OnChange"
                v-on:keyup.enter="PressEnter"
                :aria-describedby="Name"
                v-bind:value="formattedValue"
                v-on:keypress="$emit('keypress', $event)"
                v-on:input="onInput"
                v-on:focus="Focus($event)"
                v-on:keydown="$emit('keydown', $event)"
                >
        </div>
       </BaseInputWithContextMenu>
    </div>
</template>

<script>
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';
import Vue from 'vue';
import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
import validator from 'validator';
Vue.use(ContextMenuPlugin);

export default {
    name: 'MdEdit',
    props: {
        TypeProp:String,
        StepProp:String,
        MaxLengthProp: Number,
        isReadOnly:Boolean,
        Min:String,
        Max:String,
        isRequired:Boolean,
        value: [String, Number, Date],
        Name:String,
        Id:String,
        isValid:Boolean,
        Label:String,
        Placeholder:String,
        Autocomplete:Boolean,
        Mask: String,
        Tag: String,
        OnPressEnter: Function,
        OnFocus: Function,
        OnAuxFunc:Function,
        IsAux:Boolean,
        NoValidateChanges:Boolean,
        isValidDoB:Boolean,
        IdButton:String,
        Obj1:Object,
        invalidMessage:String,
        DataList:Array,
        classValueStyle:String,
        isAutoFocus:Boolean,
        classValueInvalidStyle:String
    },

    data(){
        return {
            Count:0,
            classValue: this.classValueStyle ? this.classValueStyle : "textlabel",
            autocomplete:this.Autocomplete ? 'on' : 'off',
            invalidFeedback:"",
            formattedValue: this.fromISO(this.value),
            isMounted: false
        }
    },

    computed: {
        internalClassValueStyle(){
            return this.classValueStyle ? this.classValueStyle : "textlabel";
        },

        internalClassValueInvalidStyle(){
            return this.classValueInvalidStyle ? this.classValueInvalidStyle : "textlabel-invalid";
        },

        internalPropertyType() {
            if (this.isCalendar() && !Utils.useBrowserBuildItCalendar()) {
                return 'text';
            }

            return this.TypeProp;
        },

        internalMask() {
            if (this.isCalendar() && !Utils.useBrowserBuildItCalendar()) {
                let propertyType = this.TypeProp?.toLowerCase();
                if (propertyType === 'datetime-local') {
                    return '##/##/#### ##:##';
                } else if (propertyType === 'date') {
                    return '##/##/####';
                }
            }

            return this.Mask;
        },

        internalPlaceholder() {
            let propertyType = this.TypeProp?.toLowerCase();
            if (propertyType === 'datetime-local') {
                return Utils.getFullDateTimeFormat();
            } else if (propertyType === 'date') {
                return Utils.getShortDateFormat();
            }

            return this.Placeholder;
        },

        format() {
            if (this.isCalendar() && !Utils.useBrowserBuildItCalendar()) {
                return this.TypeProp == 'date' ? Utils.getShortDateFormat() : Utils.getFullDateTimeFormat();
            }

            return this.TypeProp == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DDTHH:mm';
        },

        shortFormat() {
            if (this.isCalendar() && !Utils.useBrowserBuildItCalendar()) {
                return this.TypeProp == 'date' ? Utils.getShortDateFormat() : Utils.getSchedulerDateTimeFormat();
            }

            return this.TypeProp == 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DDTHH:mm';
        },

        invalidFeedbackMessage() {
            if (Utils.isNullOrEmptyString(this.invalidMessage)) {
                if (this.isRequired) {
                    return this.$t('Msg.RequiredField');
                } else {
                    return '';
                }
            }

            return this.invalidMessage;
        },
        inputElementId() {
           return this.Id ? String(this.Id) : `input-${this._uid}`;
        },

        isReadOnlyState() {
            return  this.isReadOnly;
        },
        enableSpeechFeatures() {
            // Solo habilitar speech si el tipo de dato es texto o sin tipo definido
            const type = this.TypeProp ? this.TypeProp.toLowerCase() : 'text';
            return type === 'text' || type === 'search' || type === 'textarea' || type === 'email' || !type;
        },

        labelCaption() {
            return !this.isRequired ? this.Label+this.invalidFeedback : this.Label+' * '+this.invalidFeedback;
        }
    },

    watch: {
        isValid: function (newValue) {
            this.classValue= newValue ? this.internalClassValueStyle : this.internalClassValueInvalidStyle;
            this.invalidFeedback = newValue ? "": ": "+this.invalidFeedbackMessage;
        },
        isValidDoB: function (newValue) {
            this.classValue= newValue ? this.internalClassValueStyle : this.internalClassValueInvalidStyle;
            this.invalidFeedback = newValue ? "": ": "+this.invalidFeedbackMessage;
        },
        value: {
            immediate: true,
            handler: function(newVal) {
                let value = newVal
                if (this.isCalendar()) {
                    value = this.fromISO(newVal);
                    if (value !== '') {
                        this.formattedValue = value;
                    }
                } else {
                    this.formattedValue = value;
                }
            }
        },
        invalidMessage(newVal) {
            this.invalidFeedback = (Utils.isNullOrEmptyString(newVal) ? "" :  ": ") + this.invalidFeedbackMessage;
        },
        classValueStyle: {
            immediate: true,
            handler(newValue) {
                this.classValue = newValue || "textlabel";
            }
        },
    },

    methods: {
        isCalendar() {
            let propertyType = this.TypeProp?.toLowerCase();
            return propertyType === 'datetime-local' || propertyType === 'date';
        },

        toISO(value) {
            if (!this.isCalendar() || Utils.useBrowserBuildItCalendar()) {
                return value;
            }

            let propertyType = this.TypeProp?.toLowerCase();
            let newValue = value;
            if (value != '') {
                if (propertyType === 'date') {
                    newValue = null;
                    if (Utils.isValidDate(value, this.format, true)) {
                        newValue = Utils.formatterDate(value, this.format);
                    }
                } else if (propertyType === 'datetime-local') {
                    newValue = null;
                    if (Utils.isValidDate(value, this.format, true) || Utils.isValidDate(value, Utils.getSchedulerDateTimeFormat(), true)) {
                        newValue = Utils.formatterToISO(value, this.format);
                    }
                }
            }

            return newValue;
        },

        fromISO(value) {
            if (!this.isCalendar() || Utils.useBrowserBuildItCalendar()) {
                return value;
            }

            let propertyType = this.TypeProp?.toLowerCase();
            let newValue = value;
            if (value != '' && value != null) {
                if (propertyType === 'date') {
                    newValue = this.formattedValue;
                    if (Utils.isValidDate(value)) {
                        newValue = Utils.formatterDateToString(this.value);
                    }
                } else if (propertyType === 'datetime-local') {
                    newValue = this.formattedValue;
                    if (Utils.isValidDate(value)) {
                        newValue = Utils.formatterDateTimeAndSecondsToString(this.value);
                    }
                }
            }

            return newValue;
        },

        setValid(state){
            this.classValue= state ? this.internalClassValueStyle : this.internalClassValueInvalidStyle;
            this.invalidFeedback = state ? "": ": "+this.invalidFeedbackMessage;
        },

        setRequired(value) {
            this.isRequired = value;
            if (!value) {
                this.classValue= this.internalClassValueStyle
                this.invalidFeedback = ""
            }
        },

        PressEnter(){
            if(this.OnPressEnter){
                this.OnPressEnter();
            }
        },

        checkIsRequired(evt){
            let Invalid = false;
            let invalidFeedback = null;
            if(evt.target.value || !evt.target.validity.valid || this.isRequired){
                if(!this.TypeProp || this.TypeProp == 'text' || this.TypeProp == 'number') {
                    Invalid = evt.target.value.trim() == "" && this.isRequired ? true : false;
                    this.invalidFeedback = Invalid ? ": "+ this.$t('Msg.RequiredField'): "";
                    invalidFeedback = this.$t('Msg.RequiredField');
                }
                else if(this.TypeProp == 'date') {
                    Invalid = !evt.target.validity.valid || (!Utils.isValidDate(evt.target.value, this.format, true) && this.isRequired) ? true : false;
                    this.invalidFeedback = Invalid ? ": "+ this.$t('Msg.InvalidField')+ " " + Utils.getShortDateFormat(): "";
                    invalidFeedback = this.$t('Msg.InvalidField')+ " " + Utils.getShortDateFormat();
                }
                else if(this.TypeProp == 'datetime-local') {
                    Invalid = !evt.target.validity.valid || (!(Utils.isValidDate(evt.target.value, this.format, true) || Utils.isValidDate(evt.target.value, this.shortFormat, true))) && this.isRequired ? true : false;
                    this.invalidFeedback = Invalid ? ": "+ this.$t('Msg.InvalidField') + " " + Utils.getFullDateTimeFormat() : "";
                    invalidFeedback = this.$t('Msg.InvalidField') + " " + Utils.getFullDateTimeFormat();
                }
                else if(this.TypeProp == 'email') {
                    if (evt.target.value.length > 0) {
                        Invalid = validator.isEmail(evt.target.value) ? false : true;
                    }
                    this.invalidFeedback = Invalid ? ": "+ this.$t('Msg.InvalidField'): "";
                    invalidFeedback = this.$t('Msg.InvalidField');
                }
            }
            this.classValue= Invalid ? this.internalClassValueInvalidStyle : this.internalClassValueStyle;
            this.$emit('isValidChange', {isValid: !Invalid, invalidFeedback: Invalid ? invalidFeedback : null});
        },

        checkIsRequiredSave(value,type,id,label){
            if (id === this.Id) {
                let Invalid = false;
                if(type === 'email') {
                    //eslint-disable-next-line
                    if (value && value.trim().length > 0) {
                        Invalid = !validator.isEmail(value);
                    } else {
                        Invalid = this.isRequired;
                    }

                    // Emitir a través del EventBus
                        EventBus.$emit('email-field-validation', {
                        field: 'email',
                        isValid: !Invalid,
                        value: value
                    });

                    const dataLabel = Invalid ? label+ (this.isRequired ? ' * ' : ' ') + this.$t('Msg.InvalidField'): label;
                    var div = document.getElementById('dv_'+id);
                    div.setAttribute("data-label", dataLabel);
                }

                document.getElementById('dv_'+id).className = Invalid ? this.internalClassValueInvalidStyle : this.internalClassValueStyle;
            }
        },

        validateRangeDate(date) {
            if (this.Max && this.Min && date) {
                let format = this.format;
                let isValid = (Utils.isValidDate(date, format, true) || (this.TypeProp == 'datetime-local' && Utils.isValidDate(date, this.shortFormat, true))) ? true : false;
                if (!isValid) {
                    if (!this.isRequired) {
                        this.classValue = !isValid ? this.internalClassValueInvalidStyle : this.internalClassValueStyle;
                        this.invalidFeedback = ": "+ this.$t('Msg.InvalidField') + " " + Utils.getShortDateFormat();
                        this.$emit('isValidChange', {isValid: isValid, invalidFeedback: isValid ? null : this.$t('Msg.InvalidField') + " " + Utils.getShortDateFormat()})
                    }
                } else {
                    isValid = Utils.isValidDateAndRangeWith (date, this.Min, this.Max, format) || (this.TypeProp == 'datetime-local' && Utils.isValidDateAndRangeWith (date, this.Min, this.Max, this.shortFormat));
                    this.classValue = !isValid ? this.internalClassValueInvalidStyle : this.internalClassValueStyle;
                    this.invalidFeedback = !isValid ? " - " + this.$t('Msg.DateOutRange'): "";
                    this.$emit('isValidChange', {isValid: isValid, invalidFeedback: isValid ? null : this.$t('Msg.DateOutRange')});
                }
            }
            if (!date) {
                this.invalidFeedback = ''
            }
        },

        OnChange(evt){
            this.checkIsRequired(evt)

            this.formattedValue = evt.target.value;
            let value = this.toISO(evt.target.value) ?? '';
            this.$emit('change', value)
        },

        onBlur(evt) {
            this.checkIsRequired(evt)
            if(this.isCalendar() && evt.target.validity.valid) {
                this.validateRangeDate(evt.target.value)
            }

            this.$emit('blur', evt.target.value)
        },

        Focus($event){
            if(this.OnFocus){
                this.OnFocus();
                this.$emit('focus', $event.target.value)
            }
        },

        setFocus(){
            this.$refs[this.Name].focus();
        },

        onInput(evt) {
            let rawValue = '';

            if (evt && evt.target) {
                // Normal case: native event
                rawValue = evt.target.value;
            } else if (typeof evt === 'string' || typeof evt === 'number') {
                // Case From BaseInputWithContextMenu o speech
                rawValue = evt;
            } else if (evt && evt.value) {
                // Custom Object Case
                rawValue = evt.value;
            }

            let value = this.toISO(rawValue) ?? '';
            this.Count++;

            // SINGLE MODIFICATION: Detect first clear on DATE
            const isDate = this.TypeProp?.toLowerCase() === 'date';
            const isClear = isDate && this.Count === 1 &&  rawValue === '' && this.formattedValue !== '';

            if (isClear) {
                this.setChangedStatus(value);
                this.formattedValue = rawValue;
                return;
            }

            if (this.Count > 1 || (this.isCalendar() && Utils.useBrowserBuildItCalendar()) || (!this.isCalendar() && !this.Mask)) {
                this.setChangedStatus(value);
            }

            this.formattedValue = rawValue;
        },

        setValueS2T( sp ){
            let sp2t = ''
            var changed = {}
            if(this.value) {
                sp2t += Array.from (this.value + ""+sp).join("");
            } else {
                sp2t = Array.from (sp).join("");
            }
            this.Value = sp2t

            changed = {
                "Changed":true,
                "ComponentName":this.Name,
                "Tag": this.Tag,
                "Value" : sp2t
            }
            this.$emit('input', sp2t);
            EventBus.$emit('onChanged', changed);
            this.setChangedStatus(sp2t);
        },

        editIsValid() {
            if (this.Name) {
                return this.$refs[this.Name].validity.valid
            }

            return false;
        },
        setChangedStatus( value ){
            this.$emit('input', value)
            var changed = {
                "Changed":true,
                "ComponentName":this.Name,
                "Tag": this.Tag,
                "Value" : value,
                "IdButton":this.IdButton,
                "Obj1":this.Obj1
            }

            if(!this.NoValidateChanges && this.isMounted){
                EventBus.$emit('onChanged', changed, this.Count);
            }

            if(this.IsAux && this.isMounted){
                this.OnAuxFunc();
            }
        },

        updateValue(newValue) {
            this.$emit('input', newValue);
        },

        getControlId() {
            return this.Name;
        },
    },

    mounted(){
        this.$nextTick(() => {
            this.isMounted = true;
        });
    },

    created() {
        EventBus.$on("onCheckValid", function (value,type,id,label) {
            this.checkIsRequiredSave(value,type,id,label);
        }.bind(this));

        EventBus.$on("receivedS2T", function (event) {
            if( event.ControlId == this.Name) {
                this.setValueS2T( event.finalSentence )
            }
        }.bind(this))
    }
};

</script>

<style>



.txt-danger input{
 color: #dc3545 !important;
}

.txt-danger input[readonly] {
   color: #dc3545 !important;
}


</style>


